<template>
  <div class="school-home ">
    <div class="banner-wrapper">
      <img src="../assets/service/banner1.png" alt="" class="banner">
    </div>
    <div class="school-home-wrapper">
      <div class="school-filter">

        <div class="filter-row flex-layout">
          <span class="filter-row-name">分类：</span>
          <div class="filter-row-ul-wrapper">
            <ul class="filter-row-ul">
              <li v-for="(item,index) in filterList" :key="index" @click="changeFilterList(item,index)"
                :class="{'active':filterClassifyId === item.value}" class="filter-row-item csp">
                {{item.label}}
              </li>
            </ul>
          </div>
        </div>

        <div class="filter-row" v-for="(item) in filterChildList" :key="item.value"
          v-show="JSON.stringify(filterChildList) != '[]'">
          <filterRow :filterList="item" @change="changeChildItem"></filterRow>
        </div>
      </div>
      <div class="school-sort flex-align-between">
        <ul class="flex-layout sort-ul">
          <li v-for="(item,index) in sortList" :key="index" :class="{'active':activeSortId === item.id}" class="csp"
            @click="changeSort(item,index)">
            {{item.name}}
          </li>
        </ul>
        <div class="search">
          <el-input @input="filterCourse()" v-model="sortSearch" size="medium" placeholder="请输入课程名称"
            style="width: 156px;" suffix-icon="el-icon-search"></el-input>
        </div>
      </div>
      <div class="school-list" v-if="courseList.length > 0">
        <ul class="flex-align card-ul">
          <li v-for="(item, index) in courseList" :key="index" class="card csp" @click="toDeatil(item,index)">
            <div class="img-wrapper">
              <img :src="downloadURL + item.cover" alt :onerror="$store.state.course.defaultCourseCover[index % 5]" />
              <!-- :onerror="$store.state.course.defaultCourseCover[index % 5]" -->
            </div>
            <div class="flex-column-between info">
              <h3 class="title wes-2">{{ item.name}}</h3>
              <!-- 我的课程 -->
              <div @click="toDeatil(item,index)">
                <!-- <div class="speaker">主讲老师：{{item.teacherName}}</div> -->
                <div class="time">
                  上课时间：{{dayjs(item.createTime).format('YYYY-MM-DD HH:mm')|| '--'}}
                </div>
              </div>
            </div>
          </li>
        </ul>
        <pagination v-show="pages.total > 0" :total="pages.total" :page.sync="pages.currentPage"
          :limit.sync="pages.pageSize" :pageSizes="[8,16,24]" @pagination="handlePageChange">
        </pagination>
      </div>
      <!-- 无课程 -->
      <!-- <Empty :show="courseList && courseList.length === 0"></Empty> -->
    </div>
  </div>
</template>

<script>
  import filterRow from "./components/course/filter_row.vue"
  export default {
    components: {
      filterRow
    },
    data() {
      return {
        filterList: [],
        filterClassifyId: null,
        filterChildList: [],
        priod: 0,
        grade: 0,
        subject: 0,
        type: 0,
        activeSortId: null,
        sortSearch: '',
        sortList: [{
            id: null,
            name: '全部'
          }, {
            id: 1,
            name: '最新'
          },
          {
            id: 2,
            name: '最热'
          }
        ],
        pages: { //分页
          currentPage: 1,
          pageSize: 8,
          total: 0,
        },
        courseList: [],
      }
    },
    methods: {
      changeFilterList(item, index) {
        this.filterChildList = this.filterList[index].children;
        this.filterClassifyId = item.value;
        this.priod = 0;
        this.grade = 0;
        this.subject = 0;
        this.type = 0;
        this.getSchoolCourseList();
      },
      changeChildItem(data) {
        // console.log(data);
        this[data.type] = data.val
        this.getSchoolCourseList();
      },
      async getFilterList() {
        let params = {
          dict: 'ws_cnu_labels'
        }
        let resData = await Api.NewHome.queryLabelList(params)
        // console.log(resData);
        if (JSON.stringify(resData.data) == '[]') return;
        this.filterList = resData.data;
        this.filterClassifyId = resData.data[0].value;
        this.filterChildList = resData.data[0].children;
        // console.log(this.filterChildList)
        this.getSchoolCourseList();
      },


      // 翻页
      handlePageChange(data) {
        this.pages.currentPage = data.pageIndex
        this.pages.pageSize = data.pageSize
        // console.log(this.pages);
        this.getSchoolCourseList();
      },
      // 切换排序类型
      changeSort(item, index) {
        this.activeSortId = item.id;
        this.getSchoolCourseList();
      },
      filterCourse(val) {
        this.getSchoolCourseList();
      },
      //获取项目下课程列表
      async getSchoolCourseList() {
        if (this.activeName === "0") return;
        let params = {
          page: this.pages.currentPage,
          limit: this.pages.pageSize,
          classify: this.filterClassifyId,
          // orderType: this.activeSortId,
        }
        params.priod = this.priod ? this.priod : null;
        params.grade = this.grade ? this.grade : null;
        params.subject = this.subject ? this.subject : null;
        params.type = this.type ? this.type : null;
        let resData = await Api.NewHome.getCourseList(params)
        // console.log(resData.data)
        this.courseList = []
        if (!resData.data || resData.data.records.lenght <= 0) return
        this.courseList = resData.data.records;
        this.pages.total = resData.data.total;
      },
      // 去详情页
      toDeatil(item, index) {
        // console.log(item);
        this.$router.push({
          path: `/courseDetail/${item.id}`,
          query: {
            // platform: item.platformType,
            // type: this.$route.query.type,
            index: index
          }
        });
      },
      checkIfIcon(type) {
        if (!type) return;
        // this.$nextTick(() => {
        //   if (this.$refs[`filter${type}Ul`].clientHeight <= 50) {
        //     this.$refs[`${type}FlodIcon`].style.display = 'none';
        //   }
        // })
      },
      // flodFilterRow(type) {
      //   this[`filter${type}fold`] = !this[`filter${type}fold`];
      //   this.$refs[`filter${type}`].style.height = this[`filter${type}fold`] ?
      //     `${this.$refs[`filter${type}Ul`].clientHeight}px` : '50px';
      // },
    },
    mounted() {
      // scroll(0, 0);
      this.getFilterList();
      // this.getSchoolCourseList();
    },
  };
</script>

<style lang="less" scoped>
  .school-home {
    // min-height: 100vh;
    background-color: #fff !important;
    padding-bottom: 10px;

    .banner {
      width: 100%;
    }

    .school-home-wrapper {
      width: 990px;
      margin: 20px auto 79px;
      // flex: 1;
    }

    // 筛选条件
    .school-filter {
      margin: 0px 0 22px;
      background-color: #fff;
      border-radius: 10px;
      box-shadow: 0px 0px 3px 0px rgba(127, 127, 127, 0.14);

      .filter-row {
        padding-left: 39px;
        border-bottom: 1px dashed rgba(191, 191, 191, .12);

        // position: relative;
        &:last-child {
          border: 0
        }

      }

      .filter-row-name {
        min-width: 60px;
        line-height: 50px;
        color: #555;
      }

      .filter-row-ul-wrapper {
        // height: 50px;
        overflow: hidden;
        -webkit-transition: height .6s;
        -moz-transition: height .6s;
        -ms-transition: height .6s;
        -o-transition: height .6s;
        transition: height .6s;

        // &.unflod-row {
        //   height: 150px;
        // }
      }

      .filter-row-ul {
        flex-grow: 1;
      }

      .filter-row-item {
        display: inline-block;
        margin: 0 10px 0px 0;
        padding: 0 20px;
        line-height: 50px;
        color: #999;

        &.active {
          color: #508EF9;
        }
      }

      .flod {
        padding-right: 15px;
        font-size: 15px;
        line-height: 50px;
        color: #999;
      }
    }

    // 排序
    .school-sort {
      background-color: #fff;
      border-radius: 10px;
      line-height: 40px;
      margin-top: 22px;
      padding: 0 15px 0 24px;
      box-shadow: 0px 0px 3px 0px rgba(127, 127, 127, 0.14);

      .sort-ul {
        li {
          display: inline-block;
          margin-right: 10px;
          padding: 0 15px;
          color: #999;
        }

        li.active {
          color: #fff;
          background-color: rgba(80, 142, 249, 1);
        }
      }

      .search {
        display: inline-block;

        /deep/ .el-input__inner {
          border: 1px solid #CECECE;
          border-radius: 25px;
          line-height: 24px;
          height: 24px;
          color: #343434;
        }
      }
    }

    // 课程列表
    .school-list {
      margin-top: 25px;

      .card-ul {
        flex-flow: row wrap;

        .card {
          position: relative;
          box-sizing: border-box;
          margin: 0 11px 22px 0;
          border-radius: 10px;
          padding: 0 0 10px 0;
          max-width: 239px;
          width: 24.5%;
          background-color: #fff;
          transition: .5s all;

          &:nth-child(4n) {
            margin-right: 0px;
          }

          &:hover {
            box-shadow: 0px 3px 18px 0px rgba(60, 108, 195, 0.19);
            transform: translateY(-5px);
          }
        }

        //li上部分
        .status {
          box-sizing: border-box;

          .kind {
            position: absolute;
            top: 0;
            right: 0;

            .course-type-image {
              width: 50px;
            }
          }

          .kind-type {
            position: absolute;
            top: 14px;
            left: 0;

            text-align: center;
            line-height: 24px;
            font-size: 14px;
            padding: 2px 12px 2px 7px;
            height: 24px;
            border-radius: 2px 12px 12px 2px;
            color: #ffffff;
            // color: #2474ec;
          }

          .background-color-1 {
            background: #F6B926;
          }

          .background-color-2 {
            background: #36C2CF;
          }

          .background-color-3 {
            background: #EF5757;
          }

          .countdown {
            color: #ff1a1a;
          }
        }

        //中间图片
        .img-wrapper {
          width: 100%;
          height: 128px;
          margin: 0px auto 5px;
          overflow: hidden;
          border-radius: 3px;

          img {
            width: 100%;
            max-width: 100%;
            border-radius: 8px;
          }
        }


        //li下部分
        h3.title {
          margin-bottom: 5px;
          height: 38px;
          font-size: 13px;
          padding: 0 11px;
          font-weight: bold;
        }


        .speaker,
        .integral,
        .time {
          padding-bottom: 3px;
          color: #595959;
          font-size: 12px;
          padding: 0 11px;
          line-height: 20px;
        }

        .other {
          margin-top: 10px;

          .otherJob {
            font-size: 15px;
            color: #888;
          }

          .toDetail {
            max-width: 119px;
            padding: 0 32px;
            text-align: center;
            background: linear-gradient(90deg, #2272ec, #3a7bf6);
            box-shadow: 0px 5px 13px 0px rgba(22, 115, 255, 0.28);
            border-radius: 5px;
            line-height: 31px;
            color: #ffffff;
          }
        }
      }

      @media screen and (min-width: 1250px) {
        .card-list {
          padding: 20px 22px;
        }

        .card-ul {
          .card {
            margin: 0 13px 29px 0;
            padding: 0 0 15px 0;
            max-width: 290px;
          }

          .img-wrapper {
            height: 155px;
            margin: 0px auto 10px;
          }

          h3.title {
            margin-bottom: 10px;
            font-size: 15px;
            height: 44px;
          }
        }
      }
    }

    @media screen and (min-width:1250px) {
      .school-home-wrapper {
        width: 1200px;
        margin: 25px auto 95px;
      }
    }

  }
</style>